import { isValidDate, isValidMemberId } from '@usas/ui-web/utils/validation';
import Constants from '@usas/ui-web/utils/Constants';
import { PersonHttpHelper, NO_DATA_MESSAGE } from '@usas/ui-web/utils/HttpHelper';

export const localValidate = (formState) => {
  let errors = {};
  const effectiveDate = new Date(formState.effectiveDate);
  const expirationDate = new Date(formState.expirationDate);

  if (formState.effectiveDate === Constants.BLANK_DATE_STRING
    || !isValidDate(formState.effectiveDate)) {
    errors.effectiveDate = 'Effective Date must be a valid date';
  }

  if (formState.expirationDate === Constants.BLANK_DATE_STRING
    || !isValidDate(formState.expirationDate)) {
    errors.expirationDate = 'End Date must be a valid date';
  }

  if (expirationDate < effectiveDate) {
    errors.effectiveDate = 'Effective Date must be before the End Date';
    errors.expirationDate = 'End Date must be after the Effective Date';
  }

  if (formState.effectiveDate !== Constants.BLANK_DATE_STRING
    && formState.expirationDate === Constants.BLANK_DATE_STRING) {
    errors.expirationDate = 'End Date is required if there is a Effective Date';
  }

  if (formState.effectiveDate === Constants.BLANK_DATE_STRING
    && formState.expirationDate !== Constants.BLANK_DATE_STRING) {
    errors.effectiveDate = 'Effective Date is required if there is a End Date';
  }

  if (formState.memberId.trim().length === 0) {
    errors.memberId = 'Member Id is required';
  }

  if (isValidMemberId(formState.memberId.trim()) === false) {
    errors.memberId = 'A valid Member Id is required';
  }

  if (formState.orgRole.length === 0) {
    errors.orgRole = 'HQ Committee Role is required';
  }

  if (formState.termLengthId < 0 || formState.termLengthName === '--' || formState.termLengthName === '') {
    errors.termLengthId = 'Selecting Term Length is required';
  }

  if (formState.representativeTypeId < 0 || formState.representativeTypeName === '--' || formState.representativeTypeName === '') {
    errors.representativeTypeId = 'Selecting Representative Type is required';
  }

  return errors;
};

const serverValidate = async (formState) => {
  let errors = {};

  const memberIdForUrl = formState.memberId ? encodeURIComponent(formState.memberId) : 'NaN';
  const url = `/Person/flat/memberId/${memberIdForUrl}`;

  await PersonHttpHelper(url, 'GET')
    .then((objData) => {
      if (!objData) {
        throw new Error(NO_DATA_MESSAGE);
      } else {
        formState.personId = objData.personId;
      }
    })
    .catch((e) => {
      errors.apiError = 'Member Id is not valid';
    });

  return errors;
};

const AddHQCommitteeMemberValidation = async (formState) => {
  let errors = localValidate(formState);
  if (!errors || Object.keys(errors).length === 0) {
    errors = await serverValidate(formState);
  }

  return errors ? errors : {};
};

export default AddHQCommitteeMemberValidation;